import { TripState } from '../../../../core-types';
import {
  CheckmarkAlt as CheckIcon,
  Clock as ClockIcon,
  CloseAlt as CrossIcon
} from '@urbaninfrastructure/react-icons';
import { FormattedDate, FormattedTime } from 'react-intl';
import { Text } from '../../../../components';
import { FormattedDuration } from '../../../../lib/util';
import { FormattedDistance } from '../../../../components/FormattedDistance';
import Rating from '@material-ui/lab/Rating';

export const TripIcon = ({ state, ...restProps }: { state: TripState }) => {
  switch (state) {
    case TripState.on_hold:
      return <ClockIcon color="neutral.4" {...restProps} />;
    case TripState.starting:
      return <ClockIcon color="state.warning" {...restProps} />;
    case TripState.in_progress:
      return <ClockIcon color="state.success" {...restProps} />;
    case TripState.completed:
      return <CheckIcon color="state.success" {...restProps} />;
    case TripState.cancelled:
    default:
      return <CrossIcon color="neutral.4" {...restProps} />;
  }
};

export const TripStartDate = ({
  startedAt,
  mute
}: {
  startedAt: string | null;
  mute?: boolean;
}) => {
  return (
    <>
      {startedAt && (
        <Text mute={mute}>
          <FormattedDate
            value={startedAt}
            month="long"
            day="numeric"
            weekday="long"
          />
        </Text>
      )}
    </>
  );
};

export const TripStation = ({
  date,
  title
}: {
  date: string | null;
  title: string | null | undefined;
}) => {
  return (
    <>
      {date && (
        <Text mute as="span">
          <FormattedTime value={date} />
        </Text>
      )}{' '}
      {title || ''}
    </>
  );
};

export const TripDuration = ({ duration }: { duration: number | null }) => {
  return (
    <>
      {typeof duration === 'number' && (
        <FormattedDuration durationMins={duration / 60} />
      )}
    </>
  );
};

export const TripDistance = ({ distance }: { distance: number | null }) => {
  return (
    <>
      {typeof distance === 'number' && (
        <FormattedDistance distanceInMeters={distance} />
      )}
    </>
  );
};

export const TripRating = ({ userRating }: { userRating: number | null }) => {
  return (
    <Rating
      name="read-only"
      readOnly
      value={userRating}
      precision={1}
      size="small"
      css={{
        marginLeft: '-6px',
        verticalAlign: 'middle',
        '& .MuiRating-icon': {
          width: '1.125rem'
        }
      }}
    />
  );
};
